import { useContext } from 'react';
import { UserContext } from '@namespace/user';
import { createApplePaySessionRequestPayload } from '../../utils';

// eslint-disable-next-line import/no-mutable-exports
export let session: ApplePaySession;

export const useApplePaySession = () => {
  const [user] = useContext(UserContext);
  const { countryId: countryCode, activeWallet = {} } = user;
  const { currency: currencyCode } = activeWallet;

  const init = (amount: string) => {
    try {
      const request = createApplePaySessionRequestPayload(
        countryCode,
        currencyCode,
        amount
      ) as ApplePayJS.ApplePayPaymentRequest;

      session = new ApplePaySession(3, request);
    } catch (e) {
      console.log(e);
    }

    return session;
  };

  return init;
};
